'use client';

import { createContext, useCallback, useContext, useState } from 'react';
import QuoteRequestModal from '@/components/QuoteRequestModal';

type QuoteRequestContextProps = {
  isOpen: boolean;
  openModal: () => void;
  closeModal: () => void;
};

export const QuoteRequestContext = createContext<QuoteRequestContextProps>({
  isOpen: false,
  openModal: () => {},
  closeModal: () => {},
});

export const QuoteRequestProvider = ({
  children,
}: {
  children: React.ReactNode;
}) => {
  const [isOpen, setIsOpen] = useState(false);

  const openModal = useCallback(() => setIsOpen(true), []);
  const closeModal = useCallback(() => setIsOpen(false), []);

  return (
    <QuoteRequestContext.Provider value={{ isOpen, openModal, closeModal }}>
      {children}
      <QuoteRequestModal />
    </QuoteRequestContext.Provider>
  );
};

export const useQuoteRequest = () => useContext(QuoteRequestContext);
